import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  textColor?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md',
  showText = false,
  textColor = 'text-gray-900 dark:text-white'
}) => {
  const [imageError, setImageError] = useState(false);

  const heightPx = size === 'sm' ? 26 : size === 'md' ? 28 : size === 'lg' ? 27 : 36;

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  return (
    <Link to="/" className={`site-logo-link flex items-center shrink-0 ${className}`}>
      {!imageError ? (
        <img
          src="/LetsBoostUpLogo-approved.png"
          alt="LetsBoostUp"
          style={{
            height: heightPx,
            width: 'auto',
            maxWidth: 'none',
            maxHeight: 'none',
            display: 'block',
            objectFit: 'contain'
          }}
          onError={() => setImageError(true)}
        />
      ) : (
        <span className={`${textSizeClasses[size]} font-bold font-display`}>
          <span className="text-primary-500">Lets</span><span className="text-white">BoostUp</span>
        </span>
      )}
      {showText && (
        <span className={`ml-3 ${textSizeClasses[size]} font-bold font-display ${textColor}`}>
          <span className="text-primary-500">Lets</span><span>BoostUp</span>
        </span>
      )}
    </Link>
  );
};

export default Logo;
